import TemplatesContainer from './TemplatesContainer';
export default TemplatesContainer;
